<p-table
    [columns]="columns"
    [value]="roles"
    [lazy]="true"
    (onLazyLoad)="getRoles($event)"
    [paginator]="true"
    [rows]="10"
    [totalRecords]="roleCount"
    [loading]="loading"
    [responsive]="true"
    styleClass="p-datatable-striped"
>
    <ng-template pTemplate="caption">
        <div class="text-right">
            <button class="btn btn-info btn-sm-block mr-1" (click)="getRoles(null)">
                <i class="fa fa-redo"></i>Listeyi Yenile
            </button>
            <ng-template [ngxPermissionsOnly]="['AddRole']">
                <button type="button" class="btn btn-primary" (click)="addRoleForm.patchValue({ id: 0 }); addRoleDialog = true">
                    <i class="fa fa-plus-circle"></i>Yeni Rol
                </button></ng-template
            >
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [ngStyle]="{ width: col.width ? col.width : 'auto' }">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="!col.custom; else customField">
                    {{ rowData[col.field] }}
                </ng-container>
                <ng-template #customField>
                    <ng-container *ngIf="col.field === 'isSystemDefault'">
                        <i *ngIf="rowData['isSystemDefault']" class="fa fa-toggle-on fa-2x text-success"></i>
                        <i *ngIf="!rowData['isSystemDefault']" class="fa fa-toggle-off fa-2x text-danger"></i>
                    </ng-container>
                    <ng-container *ngIf="col.field === 'actions'">
                        <div class="text-center">
                            <ng-template [ngxPermissionsOnly]="['UpdateRole']">
                                <button
                                    class="btn btn-warning btn-icon mr-1 btn-sm"
                                    pTooltip="Düzenle"
                                    tooltipPosition="left"
                                    [disabled]="rowData['isSystemDefault']"
                                    (click)="showDialogForRoleEdit(rowData)"
                                >
                                    <i class="fa fa-edit"></i></button
                            ></ng-template>
                            <ng-template [ngxPermissionsOnly]="['RemoveRole']">
                                <button
                                    [disabled]="rowData['isSystemDefault']"
                                    class="btn btn-danger btn-icon btn-sm"
                                    pTooltip="Sil"
                                    tooltipPosition="left"
                                    (click)="deleteRole(rowData['id'])"
                                >
                                    <i class="fa fa-trash"></i></button
                            ></ng-template>
                        </div>
                    </ng-container>
                </ng-template>
            </td>
        </tr>
    </ng-template>
    <!-- <ng-template pTemplate="summary" let-rowData>
        <div class="text-right">
            <button type="button" class="btn btn-primary" pButton icon="pi pi-plus" (click)="ekleKullanici()">
                Yeni Kullanıcı
            </button>
        </div>
    </ng-template> -->
</p-table>
<p-dialog
    header="Yeni Rol Ekle"
    [(visible)]="addRoleDialog"
    [focusOnShow]="false"
    showEffect="fade"
    [modal]="true"
    position="top"
    [appendTo]="'body'"
    styleClass="operation-dialog"
    (onHide)="addRoleForm.reset()"
>
    <form class="row" autocomplete="off" [formGroup]="addRoleForm" (ngSubmit)="addRole()">
        <div class="form-group col-md-12">
            <label for="name">Adı</label>
            <input
                id="name"
                class="form-control"
                type="text"
                formControlName="name"
                [ngClass]="{
                    'is-invalid': checkAddRoleForm('name', null, 'iv'),
                    'is-valid': checkAddRoleForm('name', null, 'v')
                }"
            />
            <div class="invalid-feedback" *ngIf="checkAddRoleForm('name', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
        </div>
        <div>
            <div class="form-check form-check-inline" *ngFor="let permission of permissions">
                <input
                    id="permissionCheck"
                    class="form-check-input"
                    type="checkbox"
                    [checked]="permission.selected"
                    (change)="permission.selected = $event.target['checked']"
                />
                <label class="form-check-label" for="permissionCheck">{{ permission.displayName }}</label>
            </div>
        </div>
        <div class="text-right col-md-12">
            <button class="btn btn-secondary mr-1" type="button" (click)="addRoleDialog = false">
                <i class="fa fa-times"></i> Kapat
            </button>
            <button class="btn btn-success"><i class="fa fa-save"></i> Kaydet</button>
        </div>
    </form>
</p-dialog>
<p-confirmDialog #cd header="Onay" icon="pi pi-exclamation-triangle" appendTo="body">
    <p-footer>
        <button class="btn btn-secondary mr-1" type="button" (click)="cd.reject()">
            <i class="fa fa-times"></i> Hayır
        </button>
        <button type="submit" class="btn btn-info" (click)="cd.accept()">
            <i class="fa fa-check"></i> Evet
        </button>
    </p-footer>
</p-confirmDialog>
